import styled from '@emotion/styled';
import { pxToRem } from '@modernhealth/vital-components';
import React from 'react';

import adminLogo from 'src/public/img/mh-central-text.svg';
import img from 'src/public/img/mh-logo-text-modern-health.svg';

const BrandImageContainer = styled.img<BrandImageProps>(
    ({ isAdminPage, clientPortalUnification }) => ({
        width: '10em',
        height: '100%',
        marginRight: isAdminPage && clientPortalUnification ? pxToRem(8) : 0,
    }),
);

const LargeBrandImageContainer = styled.img({
    width: '12em',
    margin: '1.5em 0 0 1.5em',
});

interface BrandImageProps {
    isAdminPage?: boolean;
    clientPortalUnification?: boolean;
}
export const BrandImage: React.FC<BrandImageProps> = ({ isAdminPage, clientPortalUnification }) => {
    return (
        <BrandImageContainer
            src={isAdminPage && clientPortalUnification ? adminLogo : img}
            alt="Modern Health"
            isAdminPage={isAdminPage}
            clientPortalUnification={clientPortalUnification}
        />
    );
};
export const LargeBrandImage = () => <LargeBrandImageContainer src={img} alt="Modern Health" />;
